import { VehicleInformation } from "../data/VehInfo";

const Ammunition = (options) => {
    const { ammunition } = options;
    console.log("Ammunition Data: ", ammunition);
    const className = "veh-ammunition";

    return (
        <div className={className}>
            <h2 className="veh-ammunition-title">Ammunition</h2>
            <table>
                <tr>
                    <th>Type</th>
                    <th>Capacity</th>
                </tr>
                {ammunition.map((item) => (
                    <tr>
                        <td>{item.type}</td>
                        <td>{item.capacity}</td>
                    </tr>
                ))}
            </table>
        </div>
    )
}

export default Ammunition;